import * as stylex from '@stylexjs/stylex';
import { LucideProps } from 'lucide-react';
import { IconServer } from './iconServer';
export interface IconProps extends LucideProps {
  name: string;
  styles?: stylex.StyleXStyles;
}
export function Icon({
  styles,
  ...props
}: IconProps) {
  return <IconServer {...stylex.props(styles)} {...props} />;
}